<template>
  <div class="flex flex-start">
    <record-icons
      class="mr-50"
      :record="record"
      is-vertical
      is-icons-split
    ></record-icons>

    <div class="flex flex-vertical flex-between">
      <div class="mb-100">
        <p class="lead--status">Status: {{ status.label }}</p>
        <sensitive-data-wrapper @click="openLeadModal">
          <h3 class="lead--line_1" @click="openLeadModal">{{ address.line_1 }}</h3>
          <p v-if="address.line_2" class="lead--line_2">{{ address.line_2 }}</p>
        </sensitive-data-wrapper>
      </div>

      <record-temperature-buttons
        :record-id="record.id"
        v-model="record.temperature"
      ></record-temperature-buttons>
    </div>
  </div>
</template>

<script>
import router from "../../../../../router";
import SensitiveDataWrapper from "../../../../../components/SensitiveDataWrapper.vue";

export default {
  name: "ContactingBoxRecord",
  components: {SensitiveDataWrapper},
  props: {
    record: {
      type: Object,
      required: true
    },
  },
  computed: {
    status() {
      return this.$store.getters['pipeline/statuses'].find(status => status.id === this.record.current_status_id)
    },
    address() {
      return this.$utils.formatAddressToLine1AndLine2(this.record.property);
    },
  },
  methods: {
    openLeadModal() {
      router.replace({query: {lead: this.record.id}});
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables/variables";

.lead {

  &--status {
    margin-bottom: 6px;
    color: $text-muted;
    font-size: 0.75rem;
  }

  &--line_1 {
    color: $link;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      color: $link-hover;
    }
  }

  &--line_2 {
    margin-top: 4px;
    font-size: 0.75rem;
  }
}
</style>

